const tokens = {
  "sizes.16": {
    "value": "1rem",
    "variable": "var(--sizes-16)"
  },
  "sizes.20": {
    "value": "1.25rem",
    "variable": "var(--sizes-20)"
  },
  "sizes.24": {
    "value": "1.5rem",
    "variable": "var(--sizes-24)"
  },
  "sizes.32": {
    "value": "2rem",
    "variable": "var(--sizes-32)"
  },
  "sizes.40": {
    "value": "2.5rem",
    "variable": "var(--sizes-40)"
  },
  "sizes.48": {
    "value": "3rem",
    "variable": "var(--sizes-48)"
  },
  "sizes.64": {
    "value": "4rem",
    "variable": "var(--sizes-64)"
  },
  "sizes.72": {
    "value": "4.5rem",
    "variable": "var(--sizes-72)"
  },
  "sizes.96": {
    "value": "6rem",
    "variable": "var(--sizes-96)"
  },
  "sizes.breakpoint-sm": {
    "value": "48em",
    "variable": "var(--sizes-breakpoint-sm)"
  },
  "sizes.breakpoint-md": {
    "value": "62em",
    "variable": "var(--sizes-breakpoint-md)"
  },
  "sizes.breakpoint-lg": {
    "value": "75em",
    "variable": "var(--sizes-breakpoint-lg)"
  },
  "animations.fadeIn": {
    "value": "fade-in 250ms",
    "variable": "var(--animations-fade-in)"
  },
  "animations.fadeOut": {
    "value": "fade-out 200ms",
    "variable": "var(--animations-fade-out)"
  },
  "animations.slideIn": {
    "value": "slide-in 400ms",
    "variable": "var(--animations-slide-in)"
  },
  "animations.slideOut": {
    "value": "slide-out 200ms",
    "variable": "var(--animations-slide-out)"
  },
  "animations.spin": {
    "value": "spin 1s linear infinite",
    "variable": "var(--animations-spin)"
  },
  "animations.breathe": {
    "value": "breathe 0.8s linear infinite",
    "variable": "var(--animations-breathe)"
  },
  "animations.breathe2": {
    "value": "breathe2 1.6s linear infinite",
    "variable": "var(--animations-breathe2)"
  },
  "animations.slideDown": {
    "value": "slideDown 300ms ease-in-out",
    "variable": "var(--animations-slide-down)"
  },
  "animations.slideUp": {
    "value": "slideUp 300ms ease-in-out",
    "variable": "var(--animations-slide-up)"
  },
  "fonts.body": {
    "value": "Roboto, sans-serif",
    "variable": "var(--fonts-body)"
  },
  "fonts.heading": {
    "value": "Nunito, sans-serif",
    "variable": "var(--fonts-heading)"
  },
  "breakpoints.sm": {
    "value": "48em",
    "variable": "var(--breakpoints-sm)"
  },
  "breakpoints.md": {
    "value": "62em",
    "variable": "var(--breakpoints-md)"
  },
  "breakpoints.lg": {
    "value": "75em",
    "variable": "var(--breakpoints-lg)"
  },
  "colors.highEmphasis": {
    "value": "var(--colors-high-emphasis)",
    "variable": "var(--colors-high-emphasis)"
  },
  "colors.mediumEmphasis": {
    "value": "var(--colors-medium-emphasis)",
    "variable": "var(--colors-medium-emphasis)"
  },
  "colors.lowEmphasis": {
    "value": "var(--colors-low-emphasis)",
    "variable": "var(--colors-low-emphasis)"
  },
  "colors.highBorder": {
    "value": "var(--colors-high-border)",
    "variable": "var(--colors-high-border)"
  },
  "colors.mediumBorder": {
    "value": "var(--colors-medium-border)",
    "variable": "var(--colors-medium-border)"
  },
  "colors.lowBorder": {
    "value": "var(--colors-low-border)",
    "variable": "var(--colors-low-border)"
  },
  "colors.lightBackground": {
    "value": "var(--colors-light-background)",
    "variable": "var(--colors-light-background)"
  },
  "colors.surface": {
    "value": "var(--colors-surface)",
    "variable": "var(--colors-surface)"
  },
  "colors.surfaceElevated": {
    "value": "var(--colors-surface-elevated)",
    "variable": "var(--colors-surface-elevated)"
  },
  "colors.light2": {
    "value": "var(--colors-light2)",
    "variable": "var(--colors-light2)"
  },
  "colors.light7": {
    "value": "var(--colors-light7)",
    "variable": "var(--colors-light7)"
  },
  "colors.primary": {
    "value": "var(--colors-primary)",
    "variable": "var(--colors-primary)"
  },
  "colors.primaryDarker": {
    "value": "var(--colors-primary-darker)",
    "variable": "var(--colors-primary-darker)"
  },
  "colors.primaryLighter": {
    "value": "var(--colors-primary-lighter)",
    "variable": "var(--colors-primary-lighter)"
  },
  "colors.primaryTransparent": {
    "value": "var(--colors-primary-transparent)",
    "variable": "var(--colors-primary-transparent)"
  },
  "colors.primaryTransparent2": {
    "value": "var(--colors-primary-transparent2)",
    "variable": "var(--colors-primary-transparent2)"
  },
  "colors.secondary": {
    "value": "var(--colors-secondary)",
    "variable": "var(--colors-secondary)"
  },
  "colors.secondaryDarker": {
    "value": "var(--colors-secondary-darker)",
    "variable": "var(--colors-secondary-darker)"
  },
  "colors.secondaryLighter": {
    "value": "var(--colors-secondary-lighter)",
    "variable": "var(--colors-secondary-lighter)"
  },
  "colors.secondaryTransparent": {
    "value": "var(--colors-secondary-transparent)",
    "variable": "var(--colors-secondary-transparent)"
  },
  "colors.warning": {
    "value": "var(--colors-warning)",
    "variable": "var(--colors-warning)"
  },
  "colors.warningLighter": {
    "value": "var(--colors-warning-lighter)",
    "variable": "var(--colors-warning-lighter)"
  },
  "colors.warningTransparent": {
    "value": "var(--colors-warning-transparent)",
    "variable": "var(--colors-warning-transparent)"
  },
  "colors.altMediumEmphasis": {
    "value": "var(--colors-alt-medium-emphasis)",
    "variable": "var(--colors-alt-medium-emphasis)"
  },
  "colors.success": {
    "value": "var(--colors-success)",
    "variable": "var(--colors-success)"
  },
  "colors.altSurfaceElevated": {
    "value": "var(--colors-alt-surface-elevated)",
    "variable": "var(--colors-alt-surface-elevated)"
  },
  "colors.tint1": {
    "value": "var(--colors-tint1)",
    "variable": "var(--colors-tint1)"
  },
  "colors.tint2": {
    "value": "var(--colors-tint2)",
    "variable": "var(--colors-tint2)"
  },
  "colors.tint3": {
    "value": "var(--colors-tint3)",
    "variable": "var(--colors-tint3)"
  },
  "colors.tint4": {
    "value": "var(--colors-tint4)",
    "variable": "var(--colors-tint4)"
  },
  "colors.altTint4": {
    "value": "var(--colors-alt-tint4)",
    "variable": "var(--colors-alt-tint4)"
  },
  "colors.colorPalette": {
    "value": "var(--colors-color-palette)",
    "variable": "var(--colors-color-palette)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar